(function(){
  function toast(msg){var t=document.createElement('div');t.className='vy-toast';t.setAttribute('role','status');t.textContent=msg;document.body.appendChild(t);setTimeout(function(){t.remove()},2600)}
  async function addToCart(btn){
    if(btn.dataset.busy)return; btn.dataset.busy='1';
    var label=btn.textContent; btn.disabled=true; btn.textContent='Agregando…';
    window.__vyBusyUntil=Date.now()+8000;
    var id=btn.getAttribute('data-vy-add');
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    try{
      var a=window.Shopify&&window.Shopify.actions;
      if(a&&a.updateCart){
        var r=await a.updateCart({lines:[{merchandiseId:id,quantity:1}]},{event:{context:'standard-action'}});
        if(r&&r.userErrors&&r.userErrors.length)throw new Error(r.userErrors[0].message);
        btn.classList.add('is-done');btn.textContent='✓ Agregado';
        try{a.openCart&&a.openCart()}catch(e){toast('Agregado al carrito')}
      }else{
        var res=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]})});
        var j=await res.json(); if(!res.ok)throw new Error(j.description||j.message||'Error');
        btn.classList.add('is-done');btn.textContent='✓ Agregado';toast('Agregado al carrito');
        setTimeout(function(){location.href=root+'cart'},700);
      }
    }catch(e){btn.textContent='No se pudo agregar';toast(e&&e.message?e.message:'No se pudo agregar. Probá de nuevo.')}
    setTimeout(function(){btn.disabled=false;btn.classList.remove('is-done');btn.textContent=label;delete btn.dataset.busy},2200);
  }
  document.addEventListener('click',function(e){var b=e.target.closest('[data-vy-add]');if(b){e.preventDefault();addToCart(b)}});
})();
